module.exports = __webpack_public_path__ + "img/picture_viptc01_2.f3ac1b6d.png";